import isEmail from 'validator/lib/isEmail';

import XHR from '../../utils/xhr';

export default class Newsletter {

	el = {};

	constructor(container) {
		this.el = {
			container,
			form: container.querySelector('[data-newsletter-form]'),
			input: container.querySelector('input[type="email"]'),
			honeypot: container.querySelector('input[name="b_4f0c09aa0d3c6025719bd5819_eba2b1b148"]'),
			button: container.querySelector('button[type="submit"]'),
			error: container.querySelector('[data-error-message]'),
			success: container.querySelector('[data-success-message]')
		};
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.el.form.addEventListener('submit', this.#onFormSubmit);
		this.el.input.addEventListener('focus', this.#onInputFocus);
		this.el.input.addEventListener('blur', this.#onInputBlur);
	}

	removeEventListeners() {
		this.el.form.removeEventListener('submit', this.#onFormSubmit);
		this.el.input.removeEventListener('focus', this.#onInputFocus);
		this.el.input.removeEventListener('blur', this.#onInputBlur);
	}

	#onInputFocus = () => {
		this.el.input.parentElement.classList.add('is-active');
	}

	#onInputBlur = () => {
		this.el.input.parentElement.classList.remove('is-active');
	}

	#onFormSubmit = (e) => {
		e.preventDefault();
		this.hideError();

		if (this.el.honeypot.value) {
			this.showSuccess();
			this.el.button.disabled = true;
			return;
		}

		this.el.input.value === '' || !isEmail(this.el.input.value) ? this.showError() : this.submitForm();
	}

	showSuccess() {
		this.el.success.style.display = 'block';
	}

	hideSuccess() {
		this.el.success.style.display = 'none';
	}

	showError() {
		this.el.error.style.display = 'block';
	}

	hideError() {
		this.el.error.style.display = 'none';
	}

	submitForm() {
		const data = new FormData(this.el.form);

		this.el.input.value = '';
		this.el.button.disabled = true;

		return new Promise((resolve) => {
			new XHR('json')
				.post('/php/mailchimp-newsletter.php', data)
				.then(xhr => {
					if (xhr.response.status === 'subscribed') {
						this.hideError();
						this.showSuccess();
						this.el.button.disabled = true;
						resolve();
					} else {
						this.hideSuccess();
						this.showError();
						this.el.button.disabled = false;
					}
				});
		});
	}

	destroy() {
		this.removeEventListeners();
	}

}
